import React from 'react';
import { Helmet } from 'react-helmet';
import { checkWithinSeCe } from 'components/ProtectedRoute/utils';

const ThirdPartyScripts = () => {
  if (checkWithinSeCe()) return null; // NEVER load 3rd party scripts within SeCe.

  return (
    <>
      {/* Adobe Analytics */}
      <Helmet>
        <script
          src={
            process.env.REACT_APP_AA_LAUNCH_SCRIPT_URL ||
            'https://static-staging.veeqo.com/cc/aa/dev.min.js'
          }
          type="text/javascript"
          id="aa-launch-script"
          data-testid="adobe-analytics-script"
        />
      </Helmet>
      {/* BING */}
      <Helmet
        script={[
          {
            type: 'text/javascript',
            'data-testid': 'bing-script',
            innerHTML: `(function(w,d,t,r,u)
          {
            var f,n,i;
            w[u]=w[u]||[],f=function()
            {
              var o={ti:"187191349", enableAutoSpaTracking: true};
              o.q=w[u],
              w[u]=new UET(o),
              w[u].push("pageLoad")
            },
            n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()
            {
              var s=this.readyState;
              s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
            },
            i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
          })
          (window,document,"script","//bat.bing.com/bat.js","uetq");`,
          },
        ]}
      />
    </>
  );
};

export default ThirdPartyScripts;
